export enum WorkUserThumbRating {
  ThumbsDown = 1,
  ThumbsUp = 2,
}

export interface UserWorkEngagementEntry {
  idWork: number;
  genDate: Date;
  thumbsRating: WorkUserThumbRating | null;
  officialName: string;
  imageUrlMedium: string;
  cleanUrl: string;
  idAuthor: string;
  authorName: string;
  authorCleanUrl: string;
}

export interface AlreadyReadEntry extends UserWorkEngagementEntry {
  thumbsRating: WorkUserThumbRating;
  useInRecommendations: boolean;
  yearRead: number | null;
  monthRead: number | null;
}

export interface WantToReadEntry extends UserWorkEngagementEntry {
  /** Identifier for the user's work engagement record. */
  idUserWorkEngagement: number;
  wantsToRead: boolean;
  lowestPrice: number;
  description?: string;
  engagementStatus?: UserWorkEngagementStatus;
  editionId?: number;
  idIQ?: number;
  /** Whether the work is included in the user's weekly notification email. */
  wantsWeeklyEmails: boolean;
  /** Whether the user receives an immediate notification when the work is available. */
  wantsInstantEmails: boolean;
}

export type PaginatedWorksByEngagementStatusResponse =
  | AlreadyReadEntry
  | WantToReadEntry;

export interface GetPaginatedWorksByEngagementStatusResponse {
  totalWorks: number;
  page: number;
  pageSize: number;
  works: PaginatedWorksByEngagementStatusResponse[];
}

export interface GetPaginatedWorksResponse {
  totalWorks: number;
  page: number;
  pageSize: number;
  works: AlreadyReadEntry[];
}

export interface UpdateReadDateRequest {
  idWork: number;

  year: number | null;

  month: number | null;
}

export interface UpdateRecommendationUsage {
  idWork: number;

  useInRecommendations: boolean;
}

/**
 * Response type for work user thumb rating API calls.
 */
export type WorkUserThumbRatingResult = {
  /** True if there was an error with the request. */
  isError: boolean;
  /** Error message, if any. */
  ErrorMessage: string | null;
  /** The user's current thumb rating for the work, or null if none. */
  workUserThumbRating: WorkUserThumbRating | null;
};

export enum WorksListSortingMethod {
  DateAdded = 0,
  DateFinished = 1,
  Title = 2,
}

export enum WorksListSortingOrder {
  Descending = 0,
  Ascending = 1,
}

/**
 * Possible values for the engagementStatus of a list.
 * These are used in the "status" lists like Want To Read.
 */
export enum UserWorkEngagementStatus {
  None = 0, // NULL values will tend to default to zero, so we'll keep this as default state
  AlreadyRead = 1,
  WantToRead = 2,
}

export type UserWorkEngagementStatusResponse = {
  isError: boolean;
};
